/**
 * Do not edit directly
 */

export default "PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTgsLjVBNy41LDcuNSwwLDEsMCwxNS41LDgsNy41MSw3LjUxLDAsMCwwLDgsLjVaTTE0LjUsOGE2LjQ3LDYuNDcsMCwwLDEtMS41Nyw0LjIyTDMuNzgsMy4wN0E2LjQ5LDYuNDksMCwwLDEsMTQuNSw4Wk0xLjUsOEE2LjQ3LDYuNDcsMCwwLDEsMy4wNywzLjc4bDkuMTUsOS4xNUE2LjQ5LDYuNDksMCwwLDEsMS41LDhaIi8+PC9zdmc+";